import { RouterModule, Routes } from "@angular/router";
import { TutorialListComponent } from "./components/tutorial-list/tutorial-list.component";
import { TutorialMaterialListComponent } from "./components/tutorial-material-list/tutorial-material-list.component";
import { TutorialItemArquivoComponent } from "./components/tutorial-item-arquivo/tutorial-item-arquivo.component";
import { GenericGuard } from "src/app/shared/guards/generic.guard";
import { TutorialPermissionResolver } from "./resolver/tutorial.resolver";

const commonRoutes: Routes = [
  { path: '', redirectTo: 'pesquisa-geral', pathMatch: 'full' },
  { path: 'pesquisa-geral', component: TutorialListComponent },
  { path: ':id', component: TutorialMaterialListComponent }
];

const routes: Routes = [
  { 
    path: 'user',
    resolve: { permission: TutorialPermissionResolver },
    children: [
      { path: '', redirectTo: 'pesquisa-geral', pathMatch: 'full'},
      { path: 'pesquisa-geral', component: TutorialListComponent, data: { userType: 'user' } },
      { path: ':id', component: TutorialMaterialListComponent, data: { userType: 'user' } },
      { path: ':id/doc/:idClass', component: TutorialItemArquivoComponent, data: { userType: 'user' } }
    ]
  },
  { path: 'admin',
		data: { role: 'ACL_PF_DOCUMENT_GUIDE_CONFIG' },
    resolve: { permission: TutorialPermissionResolver },
    canActivate: [GenericGuard],
    children:  [
      { path: '', redirectTo: 'pesquisa-geral', pathMatch: 'full'},
      { path: 'pesquisa-geral', component: TutorialListComponent, data: { userType: 'admin' } },
      { path: ':id', component: TutorialMaterialListComponent, data: { userType: 'admin' } },
      { path: ':id/doc/:idClass', component: TutorialItemArquivoComponent, data: { userType: 'admin' } }
    ]
  }
];
  
export const TutorialRoutes = RouterModule.forChild(routes);